import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { downloadObtr } from '@/lib/api';
import { showErrorToast } from '@/lib/toast';
import { useHubOutletContext } from './TournamentHubLayoutRoute';

// Story 109 — OBTR 1.0 export (Backgammon Poland rating list). Backgammon-
// only hub sub-page, mirror of the chess FIDE export. The backend refuses
// the download with a message naming every blocking gap (missing location,
// match length, no played matches) — surfaced via the error toast.
export function RatingExportPage() {
  const { t } = useTranslation('director');
  const { tournament } = useHubOutletContext();
  const [downloading, setDownloading] = useState(false);

  if (!tournament) {
    return (
      <div className="text-sm text-muted-foreground">
        {t('tournament_hub.loading')}
      </div>
    );
  }

  async function handleDownload() {
    if (!tournament) return;
    setDownloading(true);
    try {
      await downloadObtr(tournament.id);
    } catch (err) {
      showErrorToast(
        err instanceof Error ? err.message : t('rating_export.download_failed'),
      );
    } finally {
      setDownloading(false);
    }
  }

  return (
    <div data-testid="rating-export-page" className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">{t('rating_export.title')}</h2>
        <p className="text-sm text-muted-foreground">
          {t('rating_export.description')}
        </p>
      </div>
      <Card className="p-4">
        <p className="mb-3 text-sm text-muted-foreground">
          {t('rating_export.hint')}
        </p>
        <Button
          data-testid="download-obtr-button"
          onClick={() => void handleDownload()}
          disabled={downloading}
        >
          <FileDown className="mr-1 h-4 w-4" />
          {downloading
            ? t('rating_export.downloading')
            : t('rating_export.download')}
        </Button>
      </Card>
    </div>
  );
}
